import { Link } from "react-router-dom";
import { ArrowRight, AlertTriangle } from "lucide-react";
import { useLang } from "../../context/LangContext";
import { Reveal, SplitReveal } from "./Motion";

export const CaseTeaser = () => {
  const { t } = useLang();
  const c = t.caseTeaser;
  return (
    <section id="caso-0" data-testid="case-teaser-section" className="relative bg-[#f3efe6] py-20 text-[#0a0a0b] md:py-32">
      <div className="wrap grid gap-10 md:grid-cols-12 md:items-start">
        <div className="md:col-span-7">
          <p className="eyebrow mb-6" style={{ color: "#8c6b1f" }}>{c.eyebrow}</p>
          <h2 className="font-display text-3xl font-bold leading-[1.08] tracking-tight sm:text-4xl lg:text-5xl"><SplitReveal key={c.title} text={c.title} /></h2>
          <Reveal delay={0.15}><p className="mt-6 max-w-2xl text-base leading-relaxed text-black/70 md:text-lg">{c.text}</p></Reveal>
          <Reveal delay={0.25}>
            <p className="mt-6 flex items-start gap-2 text-xs leading-relaxed text-black/60" data-testid="case-teaser-disclaimer"><AlertTriangle className="mt-0.5 h-3.5 w-3.5 shrink-0 text-[#8c6b1f]" />{c.disclaimer}</p>
            <Link to="/case-0" data-testid="case-teaser-cta" className="btn-dark group mt-8 inline-flex">
              {c.cta} <ArrowRight className="h-4 w-4 transition-transform duration-500 group-hover:translate-x-1" />
            </Link>
          </Reveal>
        </div>
        <Reveal delay={0.2} className="md:col-span-5">
          <div className="grid grid-cols-2 overflow-hidden rounded-[28px] border border-black/10 bg-[#fafaf7]" data-testid="case-teaser-figures">
            {[[c.before, "8"], [c.after, "3"]].map(([label, v], i) => (
              <div key={label} className={`p-6 md:p-8 ${i === 0 ? "border-r border-black/10" : "bg-[#0a0a0b] text-[#fafaf7]"}`}>
                <p className={`font-mono text-[10px] uppercase tracking-[0.25em] ${i === 0 ? "text-black/55" : "text-white/55"}`}>{label}</p>
                <p className={`mt-4 font-display text-6xl font-light md:text-8xl ${i === 0 ? "text-black/80" : "gold-text"}`}>{v}<span className="text-2xl md:text-3xl"> h</span></p>
                <p className={`mt-2 text-xs ${i === 0 ? "text-black/55" : "text-white/55"}`}>{c.unit}</p>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
